// extracted by mini-css-extract-plugin
export default {"sec_tabs":"Tabs_sec_tabs__-5x67","tab":"Tabs_tab__ZjznB","active":"Tabs_active__ZgjKZ"};